var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShields = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 2.33333H9.33333C5.25 2.33333 3.5 4.66666 3.5 8.16666V19.8333C3.5 23.3333 5.25 25.6667 9.33333 25.6667H18.6667C22.75 25.6667 24.5 23.3333 24.5 19.8333V8.16666C24.5 4.66666 22.75 2.33333 18.6667 2.33333ZM9.33333 14.2917H14C14.4783 14.2917 14.875 14.6883 14.875 15.1667C14.875 15.645 14.4783 16.0417 14 16.0417H9.33333C8.855 16.0417 8.45833 15.645 8.45833 15.1667C8.45833 14.6883 8.855 14.2917 9.33333 14.2917ZM18.6667 20.7083H9.33333C8.855 20.7083 8.45833 20.3117 8.45833 19.8333C8.45833 19.355 8.855 18.9583 9.33333 18.9583H18.6667C19.145 18.9583 19.5417 19.355 19.5417 19.8333C19.5417 20.3117 19.145 20.7083 18.6667 20.7083ZM21.5833 10.7917H19.25C17.4767 10.7917 16.0417 9.35666 16.0417 7.58333V5.25C16.0417 4.77166 16.4383 4.375 16.9167 4.375C17.395 4.375 17.7917 4.77166 17.7917 5.25V7.58333C17.7917 8.38833 18.445 9.04166 19.25 9.04166H21.5833C22.0617 9.04166 22.4583 9.43833 22.4583 9.91666C22.4583 10.395 22.0617 10.7917 21.5833 10.7917Z",
    fill: "url(#paint0_linear_640_5340)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_640_5340",
    x1: 3.5,
    y1: 12.25,
    x2: 24.5,
    y2: 12.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F64E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262FED"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShields, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/shields.d99215a7.svg";
export { ForwardRef as ReactComponent };